<template>
	<TheTable
		v-if="tableData"
		:tableData="tableData"
		:loading="loading"
		:defaultSort="{ prop: 'createdDate', order: 'descending' }"
		:showMaxRows="4"
		@rowClick="goToDetailPage"
		@rowClickNewTab="goToDetailPageNewTab"
		:mobileBox="mobileBox"
	>
		<template #box>
			<BoxStatement :statement="item" v-for="item in tableData" :key="item.hid" />
		</template>

		<el-table-column prop="state" label="Status" width="120" sortable>
			<template #default="scope">
				<div class="has-status" :class="`has-status--${$getStateColor('statement', scope.row.state)}`">
					{{ $getStateFullLabel('statement', scope.row.state) }}
				</div>
			</template>
		</el-table-column>
		<el-table-column prop="hid" label="ID" width="100" sortable />
		<el-table-column prop="" label="Datum" width="100" sortable>
			<template #default="scope">
				<span>{{ $formatDate(scope.row.createdDate) }}</span>
			</template>
		</el-table-column>
		<el-table-column prop="title" label="Titel" min-width="120" sortable />
		<el-table-column prop="" label="Anhang" width="120" sortable :sort-method="$sortAttachments">
			<template #default="scope">
				<el-icon v-if="scope.row.files.length > 0 || scope.row.links.length > 0"><Paperclip /></el-icon>
				<span v-else>-</span>
			</template>
		</el-table-column>
		<el-table-column prop="contact.company" label="Organisation" width="120" sortable>
			<template #default="scope">
				<span>{{ scope.row.contact.company ? scope.row.contact.company : '-' }}</span>
			</template>
		</el-table-column>
		<el-table-column prop="contact.email" label="E-Mail" width="200" sortable v-if="shouldSeePersonalData" />
		<el-table-column
			prop=""
			label="Stn. bis"
			width="100"
			sortable
			:sort-method="(a, b) => $sortDates(a.lastValidDate ? a.lastValidDate : a.firstValidDate, b.lastValidDate ? b.lastValidDate : b.firstValidDate)"
		>
			<template #default="scope">
				<span>{{ scope.row.lastValidDate ? $formatDate(scope.row.lastValidDate) : $formatDate(scope.row.firstValidDate) }}</span>
			</template>
		</el-table-column>
	</TheTable>

	<TablePagination :currentLength="tableData.length" :totalMaxVal="totalCount" @loadNextPage="$emit('loadNextPage')" />
</template>

<script lang="ts">
import TheTable from '../TheTable.vue';
import TablePagination from './TablePagination.vue';
import { Paperclip } from '@element-plus/icons-vue';

import { StatementResponse } from '../../types/types';
import { useStore } from '@/store';
import { defineComponent, PropType } from 'vue';
import BoxStatement from '../boxes/BoxStatement.vue';

export default defineComponent({
	name: 'StatementsTable',
	data() {
		return {};
	},
	setup() {
		const store = useStore();

		return {
			store,
		};
	},
	props: {
		tableData: {
			type: Array as PropType<StatementResponse[]>,
			default: [],
			required: true,
		},
		loading: {
			type: Boolean,
			default: false,
		},
		totalCount: {
			type: Number,
			default: 0,
		},
		shouldSeePersonalData: {
			type: Boolean,
			default: false,
		},
		mobileBox: {
			type: Boolean,
			default: false,
		},
	},
	emits: ['loadNextPage'],
	components: {
		TheTable,
		TablePagination,
		Paperclip,
		BoxStatement,
	},
	computed: {},
	methods: {
		goToDetailPage(row: StatementResponse) {
			this.$router.push({ name: 'StellungnahmeDetail', params: { id: String(row.id) } });
		},
		goToDetailPageNewTab(row: StatementResponse) {
			window.open(this.$router.resolve({ name: 'StellungnahmeDetail', params: { id: String(row.id) } }).href, '_blank');
		},
	},
});
</script>
